import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import { eye_view, Search_icon, tootltip, view_icon } from "../../assets/img";
import { Table } from "../../components/Table/Table";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import DateRange from "../../components/DateRange/DateRange";
import moment from "moment";
import { checkPermission } from "../redux/api/PermissionManager";
import ReadNotificationPopup from "../../components/ReadNotificationPopup";
import { toast } from "react-toastify";
import UnReadNotificationPopup from "../../components/UnReadNotificationPopup";

// Options shown as checkboxes in the "Add Reason" popup
const REASON_OPTIONS = ["Release room and user amount", "Release room"];

const TransactionListComp = ({ type, optionsList }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const path = pathname?.replace("/", "") + type;
  const { paginationData, setpaginationData } = useGlobalContext();
  const [openPop, setOpenPop] = useState(false);
  const [filterByBookedDate, setFilterByBookedDate] = useState(false);
  const [selectedOwners, setSelectedOwners] = useState([]);
  const [showSubmitPopup, setShowSubmitPopup] = useState(false);
  const [cancleStatus, setCancleStatus] = useState("Hotel Requested");
  const [submissionDescription, setSubmissionDescription] = useState("");
  const [isViewDetails, setIsViewDetails] = useState({
    ispopUp: false,
    details: {},
  });
  const [count, setCount] = useState(0);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
  });
  const [transactionList, setTransactionList] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState(
    paginationData?.[path] ?? {
      from: moment().format("YYYY-MM-DD"),
      to: moment().format("YYYY-MM-DD"),
      category: "",
      serviceType: "",
      search: "",
      unread_only: false,
    },
  );
  const [page, setPage] = useState(1);

  // Step 1: "Add Reason" popup (Image 1) — opened when "Responded" is clicked
  const [addReasonPopup, setAddReasonPopup] = useState({
    show: false,
    row: null,
  });
  const [selectedReasonOption, setSelectedReasonOption] = useState("");

  // Step 2: "Reason" confirmation popup (Image 2) — opened after Submit
  const [confirmResponsePopup, setConfirmResponsePopup] = useState({
    show: false,
    row: null,
    reason: "",
  });

  const handleChangeFilter = (name, val) => {
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
    setPage(1);
  };

  useEffect(() => {
    let { from, to } = selectedFilter;
    if ((from && to) || (!from && !to)) getList(page);
    setpaginationData((prev) => ({
      ...prev,
      [path]: {
        ...prev?.[path],
        page: page,
        ...selectedFilter,
      },
    }));
  }, [selectedFilter, page, filterByBookedDate, cancleStatus]);

  useEffect(() => {
    setSelectedFilter((prev) => ({
      ...prev,
      from: moment().format("YYYY-MM-DD"),
      to: moment().format("YYYY-MM-DD"),
    }));
  }, []);

  const getList = async (page = 1) => {
    const {
      category,
      from,
      search,
      serviceType,
      to,
      unread_only,
      bookedFrom,
      bookedTo,
    } = selectedFilter;

    let payload = { status: type };
    if (category) payload.hotel_category = category?.value;

    if (from && to && !filterByBookedDate) {
      payload.from_date = from;
      payload.to_date = to;
    }

    if (filterByBookedDate && bookedFrom && bookedTo) {
      payload.booked_from_date = moment(bookedFrom).format("YYYY-MM-DD");
      payload.booked_to_date = bookedTo;
    }

    if (search) payload.search = search;
    if (serviceType) payload.service_type = serviceType?.value;
    if (type === "Cancelled") {
      payload.cancle_status =
        cancleStatus == "Hotel Requested"
          ? "hotel_requested"
          : cancleStatus.toLocaleLowerCase();
    }
    const unreadParam =
      type === "Hold" || type === "Cancelled"
        ? `&unread_only=${unread_only}`
        : "";

    const url = `${URLS.TRANSACTIONS}?page=${page}${unreadParam}`;

    let res = await post(url, payload);
    if (res?.status === "success") {
      setTransactionList(res?.data);
      setCount(res?.count);
      setPagination({
        current_page: res?.current_page,
        last_page: res?.total_pages,
      });
    }
  };

  // ---------- Responded / Accept flow handlers ----------

  // "Responded" clicked -> open Step 1 popup (Add Reason)
  const openAddReasonPopup = (row) => {
    setSelectedReasonOption("");
    setAddReasonPopup({ show: true, row });
  };

  const closeAddReasonPopup = () => {
    setAddReasonPopup({ show: false, row: null });
    setSelectedReasonOption("");
    setConfirmResponsePopup({
      show: false,
      row: null,
      reason: "",
    });
  };

  // Step 1 Submit -> move to Step 2 (Reason confirmation)
  const handleAddReasonSubmit = async () => {
    if (!selectedReasonOption) {
      toast.error("Please select Reason");
      return;
    }
    let payload = {
      booking_code: addReasonPopup?.row?.booking_code,
      release_type:
        selectedReasonOption === "Release room and user amount"
          ? "room_and_user_amount"
          : "room_only",
    };
    let res = await post(URLS.TRANSACTIONS_CANCEL_ACCEPT, payload);
    if (res?.status === "success") {
      toast.success(res?.message);
      closeAddReasonPopup();
      getList(page);
    }
    closeAddReasonPopup();
  };

  // Step 2 "Go Back" -> return to Step 1, keep previous selection
  const handleGoBackToReasonOptions = () => {
    setAddReasonPopup({ show: true, row: confirmResponsePopup.row });
    setSelectedReasonOption("");
    setConfirmResponsePopup({ show: false, row: null, reason: "" });
  };

  const closeConfirmResponsePopup = () => {
    setConfirmResponsePopup({ show: false, row: null, reason: "" });
  };

  // Step 2 "Confirm Responded" -> submit to API
  const handleConfirmResponded = async () => {
    try {
      let payload = {
        booking_code: confirmResponsePopup.row?.booking_code,
        message: confirmResponsePopup.reason,
      };
      let res = await post(URLS.TRANSACTIONS_CANCEL_REJECT, payload);
      if (res?.status === "success") {
        toast.success(res?.message);
        closeConfirmResponsePopup();
        getList(page);
      }
    } catch (error) {
      console.error("Error updating response status:", error);
    }
  };

  // "Accept" clicked -> direct action, no popup
  const handleAcceptRow = async (row) => {
    try {
      let payload = {
        booking_id: row?.booking_id,
        status: "accepted",
      };
      let res = await post(URLS.CANCLE_STATUS_UPDATE, payload);
      if (res?.status === "success") {
        toast.success("Accepted successfully");
        getList(page);
      }
    } catch (error) {
      console.error("Error accepting row:", error);
    }
  };

  // ---------------------------------------------------------

  const columns = React.useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ row }) => {
          const pageSize = 10;
          const isSelected = selectedOwners.includes(
            row.original.unread_notification_id,
          );

          const handleCheckboxChange = (e) => {
            if (e.target.checked) {
              setSelectedOwners((prev) => [
                ...prev,
                row.original.unread_notification_id,
              ]);
            } else {
              setSelectedOwners((prev) =>
                prev.filter((id) => id !== row.original.unread_notification_id),
              );
            }
          };

          return (
            <div
              style={{
                flexDirection: "row-reverse",
                alignItems: "center",
                display: "flex",
                gap: 5,
              }}
            >
              <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>

              {row?.original?.has_unread_notification &&
                (type === "Hold" || type === "Cancelled") && (
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={handleCheckboxChange}
                    style={{ width: 20, height: 20, marginTop: 9 }}
                  />
                )}

              {(type === "Hold" || type === "Cancelled") &&
                !row?.original?.has_unread_notification && (
                  <img
                    src={eye_view}
                    style={{ width: 20, height: 20, marginTop: 5 }}
                    onClick={() => {
                      setIsViewDetails((prev) => ({
                        ...prev,
                        ispopUp: true,
                        details: row?.original,
                      }));
                    }}
                  />
                )}
            </div>
          );
        },
      },
      {
        Header: "Booked date",
        accessor: "booked_date",
        Cell: ({ value }) => <p>{value}</p>,
      },
      ...(type === "Refund"
        ? [
            {
              Header: "User Code",
              accessor: "user_code",
              Cell: ({ value, row }) => (
                <p
                  onClick={() => {
                    if (
                      type !== "Refund" &&
                      checkPermission("CAN-VIEW-TRANSACTION")
                    )
                      navigate("/customer-view", {
                        state: {
                          type: {
                            ...row.original,
                            ...row.original?.user_details,
                          },
                        },
                      });
                  }}
                  className="primary pointer"
                >
                  {value}
                </p>
              ),
            },
          ]
        : []),
      ...(type === "Refund"
        ? [
            {
              Header: "User Name",
              accessor: "user_name",
              Cell: ({ value, row }) => (
                <p
                  onClick={() => {
                    if (
                      type !== "Refund" &&
                      checkPermission("CAN-VIEW-TRANSACTION")
                    )
                      navigate("/booking-list-view", {
                        state: {
                          type: "edit",
                          booking_id: row.original?.booking_id,
                        },
                      });
                  }}
                  className="primary pointer"
                >
                  {value}
                </p>
              ),
            },
          ]
        : []),
      {
        Header: "Transaction ID",
        accessor: "transaction_id",
        Cell: ({ value, row }) => (
          <p
            onClick={() => {
              if (type !== "Refund" && checkPermission("CAN-VIEW-TRANSACTION"))
                navigate("/booking-list-view", {
                  state: {
                    type: "edit",
                    booking_id: row.original?.booking_id,
                  },
                });
            }}
            className="primary pointer"
          >
            {value}
          </p>
        ),
      },
      {
        Header: "Property",
        accessor: "property_name",
        Cell: ({ value }) => <p className="primary pointer">{value}</p>,
      },
      {
        Header: "Owner",
        accessor: "owner",
        Cell: ({ value }) => <p className="primary pointer">{value}</p>,
      },
      {
        Header: "Booking ID",
        accessor: "booking_code",
        Cell: ({ value, row }) => (
          <p
            onClick={() => {
              if (checkPermission("CAN-VIEW-TRANSACTION"))
                navigate("/booking-list-view", {
                  state: {
                    type: "edit",
                    booking_id: row.original?.booking_id,
                  },
                });
            }}
            className="primary pointer"
          >
            {value}
          </p>
        ),
      },
      {
        Header: "City",
        accessor: "city",
        Cell: ({ value }) => <p className="text-nowrap">{value}</p>,
      },
      {
        Header: "Service Type",
        accessor: "service_type_name",
        Cell: ({ value }) => <p className="text-nowrap">{value}</p>,
      },
      {
        Header: "Room Type",
        accessor: "room_type",
        Cell: ({ value }) => <p className="text-nowrap">{value}</p>,
      },
      {
        Header: "Hotel Category",
        accessor: "hotel_category",
        Cell: ({ value }) => <p className="text-nowrap">{value}</p>,
      },
      {
        Header: "Property Price",
        accessor: "property_price",
        Cell: ({ value }) => <p className="text-nowrap">{value}</p>,
      },
      {
        Header: "Paid Amount",
        accessor: "paid_amount",
        Cell: ({ value }) => <p className="text-nowrap">{value}</p>,
      },
      {
        Header: "Check In Date",
        accessor: "check_in_date",
        Cell: ({ value }) => <p className="text-nowrap">{value}</p>,
      },
      {
        Header: "Check Out Date",
        accessor: "check_out_date",
        Cell: ({ value }) => <p className="text-nowrap">{value || "-"}</p>,
      },
      {
        Header: "No of Days",
        accessor: "no_of_days",
        Cell: ({ value }) => <p className="text-nowrap">{value || "-"}</p>,
      },
      {
        Header: "Room Count",
        accessor: "room_count",
        Cell: ({ value }) => <p className="text-nowrap">{value || "-"}</p>,
      },
      {
        Header: "Slot",
        accessor: "slot",
        Cell: ({ value }) => <p style={{ width: "130px" }}>{value}</p>,
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => (
          <div className="d-flex ac-js gap-2">
            <button
              className={`${
                type === "Cancelled"
                  ? "deactive-btn"
                  : type === "Hold"
                    ? "hold-btn"
                    : "active-btn"
              } p-2 w-100 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16`}
              style={{ cursor: "default" }}
            >
              {value}
            </button>
            {(type === "Cancelled" || type === "Hold") && (
              <img
                src={tootltip}
                onClick={() => setOpenPop(row.original?.reason)}
                className="tooltip-icon"
                alt=""
              />
            )}
          </div>
        ),
      },
    ];

    let action = {
      Header: "View",
      accessor: "booking_id",
      Cell: ({ value }) => (
        <div className="d-flex ac-js gap-3">
          {checkPermission("CAN-VIEW-TRANSACTION") && (
            <button
              onClick={() =>
                navigate("/booking-list-view", {
                  state: { type: "edit", booking_id: value },
                })
              }
              className="cust-btn"
            >
              <img src={view_icon} alt="" className="edit-btn" />
            </button>
          )}
        </div>
      ),
    };

    // "Responded" -> opens Add Reason popup (Image 1)
    // "Accept"    -> direct accept action
    let refer_id = {
      Header: "Action",
      accessor: "Action",
      Cell: ({ row }) => (
        <div className="d-flex ac-js gap-3">
          <div
            style={{
              background: "#FF7B00",
              padding: "10px 20px",
              cursor: "pointer",
              borderRadius: 10,
            }}
            onClick={() =>
              setConfirmResponsePopup({
                show: true,
                row: row.original,
                // reason: reasonText,
              })
            }
          >
            <p style={{ margin: 0, color: "#fff" }}>Reject</p>
          </div>
          <div
            style={{
              cursor: "pointer",
              background: "#34C759",
              padding: "10px 20px",
              borderRadius: 10,
            }}
            onClick={() => openAddReasonPopup(row.original)}
          >
            <p style={{ margin: 0, color: "#fff" }}>Accept</p>
          </div>
        </div>
      ),
    };

    if (type === "Cancelled" && cancleStatus === "Hotel Requested") {
      return [...d, refer_id];
    }

    if (type === "Refund") {
      return d;
    }

    return checkPermission("CAN-VIEW-TRANSACTION") ? [...d, action] : d;
  }, [page, selectedOwners, cancleStatus, type]);

  const handleSumbit = async () => {
    let payload = {
      ids: selectedOwners,
      description: submissionDescription,
    };
    try {
      let res = await post(URLS.NOTIFICATION_COUNTREDUCE, payload);
      if (res?.status === "success") {
        toast.success("Read Notification has been Success");
        setShowSubmitPopup(false);
        setSubmissionDescription("");
        setSelectedOwners([]);
        getList(page);
      }
    } catch (error) {
      console.error("Error fetching booking data:", error);
    }
  };

  return (
    <div>
      <h2 className="f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 mt-5">
        Total: {count}
      </h2>
      {(type === "Hold" || type === "Cancelled") && (
        <div className="d-flex" style={{ alignItems: "center" }}>
          <input
            type="checkbox"
            checked={selectedFilter?.unread_only}
            onChange={() =>
              handleChangeFilter("unread_only", !selectedFilter?.unread_only)
            }
          />
          <p className="f3 ms-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15">
            Check New Notification
          </p>
        </div>
      )}
      <div className="d-flex ae-jb mt-3 gap-1 flex-wrap mt-2">
        <div>
          {type !== "Refund" && (
            <div className="d-flex gap-1">
              <div className="d-flex gap-1">
                <input
                  type="checkbox"
                  checked={filterByBookedDate}
                  onChange={(e) => {
                    setFilterByBookedDate(e.target.checked);
                    if (!e.target.checked) {
                      handleChangeFilter("bookedFrom", "");
                      handleChangeFilter("bookedTo", "");
                    }
                  }}
                />
                <p className="f3 ms-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15">
                  Filter with Booked Date
                </p>
              </div>
              <div className="d-flex gap-1">
                <input
                  type="checkbox"
                  checked={!filterByBookedDate}
                  onChange={(e) => {
                    setFilterByBookedDate(!e.target.checked);
                    if (!e.target.checked) {
                      handleChangeFilter("from", "");
                      handleChangeFilter("to", "");
                    }
                  }}
                />
                <p className="f3 ms-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15">
                  Filter by Check-In and Check-Out Dates{" "}
                </p>
              </div>
            </div>
          )}
          {!filterByBookedDate && (
            <DateRange
              paginationPath={path}
              fromValue={
                type === "CheckIn"
                  ? moment().format("YYYY-MM-DD")
                  : selectedFilter.from
              }
              toValue={selectedFilter.to}
              disabled={type === "CheckIn"}
              hideToRange={type === "CheckIn"}
              setFromDate={(date) => {
                handleChangeFilter("from", date);
                if (type === "CheckIn") handleChangeFilter("to", date);
              }}
              setToDate={(date) => handleChangeFilter("to", date)}
            />
          )}

          {filterByBookedDate && (
            <DateRange
              paginationPath={path}
              fromValue={
                type === "CheckIn"
                  ? moment().format("YYYY-MM-DD")
                  : selectedFilter.bookedFrom
              }
              toValue={selectedFilter.bookedTo}
              setFromDate={(date) => {
                handleChangeFilter("bookedFrom", date);
                if (type === "CheckIn") handleChangeFilter("bookedTo", date);
              }}
              setToDate={(date) => handleChangeFilter("bookedTo", date)}
            />
          )}
        </div>
        <div className="d-flex gap-1">
          <Select
            className="location-search"
            options={optionsList?.category}
            onChange={(e) => handleChangeFilter("category", e)}
            isClearable
            value={selectedFilter?.category}
            placeholder="Category"
          />
          <Select
            className="location-search"
            options={optionsList?.serviceType}
            onChange={(e) => handleChangeFilter("serviceType", e)}
            isClearable
            value={selectedFilter?.serviceType}
            placeholder="Service Type"
          />
          <div className="search-input">
            <input
              onChange={(e) => handleChangeFilter("search", e.target.value)}
              type="text"
              placeholder="Search"
              style={{ border: "none", width: "150px" }}
              value={selectedFilter.search}
            />
            <img src={Search_icon} className="search-here" alt="" />
          </div>
        </div>
      </div>
      {selectedOwners.length > 0 && (
        <div
          className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn mt-2"
          style={{ width: 90 }}
          onClick={() => setShowSubmitPopup(true)}
        >
          <p>Submit</p>
        </div>
      )}
      {type === "Cancelled" && (
        <div className="d-flex ac-js gap-4 mt-4">
          {["Hotel Requested", "Accepted", "Rejected"].map((ele, ind) => {
            return (
              <p
                key={ind}
                onClick={() => {
                  setCancleStatus(ele);
                }}
                className={`${
                  cancleStatus === ele ? "prim-btn" : "sec"
                } f4 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 pointer ${
                  ind != 0 && "ms-4"
                }`}
              >
                {ele}{" "}
              </p>
            );
          })}
        </div>
      )}
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={transactionList}
        show={true}
        getRowProps={(row) => ({
          style: {
            backgroundColor: row.original.has_unread_notification
              ? "#eeeeee91"
              : "#fff",
          },
        })}
      />
      {Boolean(openPop) && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-je mb-4">
              <CancelOutlinedIcon
                className="pointer"
                onClick={() => setOpenPop(false)}
              />
            </div>
            <div className="w-100 mt-3 d-flex flex-wrap ac-jc gap-4">
              <div className="w-80">
                <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 text-start">
                  {type} Reason
                </p>
                <textarea
                  className="input-box mt-1 w-100"
                  value={openPop}
                  placeholder="Describe..."
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* STEP 1: "Add Reason" popup — Image 1 */}
      {addReasonPopup.show && (
        <div className="img-popup-design">
          <div
            className="img-popup"
            style={{
              maxWidth: 380,
              padding: "32px 28px",
              textAlign: "center",
              borderRadius: 16,
            }}
          >
            <div
              style={{
                width: 72,
                height: 72,
                borderRadius: "50%",
                background: "#EFE3FB",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 16px",
              }}
            >
              <DescriptionOutlinedIcon
                style={{ color: "#8A2BE2", fontSize: 32 }}
              />
            </div>
            <p
              className="f3 fs-sm-16 fs-md-18 fs-lg-20 fs-xl-22"
              style={{ marginBottom: 20 }}
            >
              Add Reason
            </p>
            <div style={{ textAlign: "left", marginBottom: 24 }}>
              {REASON_OPTIONS.map((option) => (
                <label
                  key={option}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                    marginBottom: 16,
                    cursor: "pointer",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={selectedReasonOption === option}
                    onChange={() => setSelectedReasonOption(option)}
                    style={{ width: 20, height: 20 }}
                  />
                  <span className="fs-sm-13 fs-md-14 fs-lg-15">{option}</span>
                </label>
              ))}
            </div>
            <hr style={{ border: "none", borderTop: "1px solid #eee" }} />
            <button
              className="white"
              style={{
                width: "100%",
                marginTop: 20,
                padding: "12px 0",
                background: "#8A2BE2",
                border: "none",
                borderRadius: 8,
                fontSize: 15,
                cursor: "pointer",
              }}
              onClick={handleAddReasonSubmit}
            >
              Submit
            </button>
            <p
              className="pointer"
              style={{ marginTop: 12, color: "#888", fontSize: 13 }}
              onClick={closeAddReasonPopup}
            >
              Cancel
            </p>
          </div>
        </div>
      )}

      {/* STEP 2: "Reason" confirmation popup — Image 2 */}
      {confirmResponsePopup.show && (
        <div className="img-popup-design">
          <div
            className="img-popup"
            style={{
              maxWidth: 420,
              padding: "28px 28px",
              borderRadius: 16,
            }}
          >
            <p
              className="f3 fs-sm-16 fs-md-18 fs-lg-20"
              style={{ textAlign: "center", marginBottom: 20 }}
            >
              Reason
            </p>
            <input
              type="text"
              className="input-box w-100"
              value={confirmResponsePopup.reason}
              onChange={(e) =>
                setConfirmResponsePopup((prev) => ({
                  ...prev,
                  reason: e.target.value,
                }))
              }
              placeholder="Release room and user amount"
              style={{
                border: "none",
                borderBottom: "1px solid #ccc",
                width: "100%",
                padding: "8px 0",
                marginBottom: 28,
                outline: "none",
              }}
            />
            <div className="d-flex ac-jb">
              <p
                className="pointer"
                style={{ fontSize: 15 }}
                onClick={closeAddReasonPopup}
              >
                Go Back
              </p>
              <button
                style={{
                  background: "#FADCDC",
                  color: "#E14444",
                  border: "none",
                  borderRadius: 8,
                  padding: "10px 20px",
                  fontSize: 15,
                  cursor: "pointer",
                }}
                onClick={handleConfirmResponded}
              >
                Confirm Responded
              </button>
            </div>
          </div>
        </div>
      )}

      {showSubmitPopup && (
        <ReadNotificationPopup
          setSubmissionDescription={setSubmissionDescription}
          setShowSubmitPopup={setShowSubmitPopup}
          submissionDescription={submissionDescription}
          handleSumbit={handleSumbit}
        />
      )}
      {isViewDetails?.ispopUp && (
        <UnReadNotificationPopup
          setIsViewDetails={setIsViewDetails}
          isViewDetails={isViewDetails}
        />
      )}
    </div>
  );
};

export default TransactionListComp;
